import { render } from "./AccountProfile.vue?vue&type=template&id=4c84ed4f&scoped=true&lang=pug"
import script from "./AccountProfile.vue?vue&type=script&lang=js"
export * from "./AccountProfile.vue?vue&type=script&lang=js"

import "./AccountProfile.vue?vue&type=style&index=0&id=4c84ed4f&scoped=true&lang=css"

import exportComponent from "/Users/juvicmartires/Documents/BreakingHits/breakinghits-vuejs-website/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4c84ed4f"]])

export default __exports__